<template>
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>icons / 24x24 / products</title>
      <g id="icons-/-24x24-/-products" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
        <g id="product" transform="translate(3.000000, 3.000000)" stroke="#97ABBE" stroke-width="2">
          <rect id="Rectangle" x="0" y="0" width="7" height="7"></rect>
          <rect id="Rectangle" x="11" y="0" width="7" height="7"></rect>
          <rect id="Rectangle" x="11" y="11" width="7" height="7"></rect>
          <rect id="Rectangle" x="0" y="11" width="7" height="7"></rect>
        </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "iconProducts"
}
</script>